import { View } from 'react-native';
import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';

export interface LabeledSectionLabelProps {
  className?: string;
  children: string;
}

const LabeledSectionLabel = ({
  className,
  children,
}: LabeledSectionLabelProps) => {
  return (
    <View className={cn('w-full flex-row items-center gap-3', className)}>
      <View className="w-6 h-0.5 bg-accent rounded-sm" />
      <Text className="font-inter font-bold text-[11px] text-text-secondary tracking-[2px] uppercase">
        {children}
      </Text>
    </View>
  );
};

export interface LabeledSectionRootProps {
  className?: string;
  children: React.ReactNode;
}

const LabeledSectionRoot = ({
  className,
  children,
}: LabeledSectionRootProps) => {
  return (
    <View className={cn('w-full flex-col gap-3', className)}>{children}</View>
  );
};

export const LabeledSection = Object.assign(LabeledSectionRoot, {
  Root: LabeledSectionRoot,
  Label: LabeledSectionLabel,
});
